import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { api, USER_ID, track } from "../api";
import { DishCard, rewardToast, OrderButton } from "../components";
import { ModuleGate } from "../flags";
import { shareBadge } from "../share";
import { Share2 } from "lucide-react";

export default function QuizPage() {
  return (
    <ModuleGate flag="food_quizzes">
      <QuizInner />
    </ModuleGate>
  );
}

function QuizInner() {
  const [quiz, setQuiz] = useState(null);
  const [idx, setIdx] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [result, setResult] = useState(null);

  useEffect(() => {
    api.get("/quizzes/personality").then((r) => setQuiz(r.data));
    track("quiz_started", { slug: "what-punjabi-dish-are-you" });
  }, []);

  if (!quiz) return <div className="p-6 text-white/50 text-sm">Loading quiz…</div>;

  const answer = async (i) => {
    const next = [...answers, i];
    setAnswers(next);
    if (idx < quiz.questions.length - 1) {
      setIdx(idx + 1);
    } else {
      const r = await api.post("/quizzes/personality/submit", { user_id: USER_ID, answers: next });
      rewardToast(r.data);
      setResult(r.data);
    }
  };

  if (result) {
    const p = result.profile;
    return (
      <div data-testid="quiz-result" className="px-4 pt-8 pb-10 mx-auto w-full max-w-3xl">
        <p className="text-[10px] tracking-[0.35em] text-[#D4AF37]">YOUR FOOD PERSONALITY</p>
        <motion.h1 initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="font-display text-4xl font-bold tracking-tighter mt-2" data-testid="quiz-result-name">
          {p.name}
        </motion.h1>
        <div className="flex flex-wrap gap-2 mt-4">
          {p.likes.map((l) => (
            <span key={l} className="rounded-full bg-[#1A1A1A] border border-[#D4AF37]/30 px-3 py-1.5 text-xs text-[#D4AF37]">{l}</span>
          ))}
        </div>
        <button
          data-testid="share-personality-btn"
          onClick={() => shareBadge(p.name, `Likes: ${p.likes.join(", ")}`, "MY FOOD PERSONALITY")}
          className="mt-5 flex items-center gap-2 border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37]/10 text-xs font-bold rounded-full px-5 py-3 tracking-widest"
        >
          <Share2 size={14} /> SHARE MY PERSONALITY
        </button>
        <p className="text-[10px] tracking-[0.25em] text-[#D4AF37] mt-8 mb-3">RECOMMENDED FOR YOU</p>
        <div className="grid grid-cols-1 gap-3">
          {p.dish_details.map((d) => <DishCard key={d.slug} dish={d} />)}
        </div>
        <OrderButton label="BUILD MY ORDER" source="quiz_result" testId="quiz-build-order" className="w-full mt-6" />
      </div>
    );
  }

  const q = quiz.questions[idx];
  return (
    <div data-testid="quiz-page" className="px-4 pt-8 pb-10 min-h-[70vh] flex flex-col mx-auto w-full max-w-3xl">
      <p className="text-[10px] tracking-[0.35em] text-[#D4AF37]">FOOD QUIZ · {idx + 1} / {quiz.questions.length}</p>
      <h1 className="font-display text-3xl font-bold tracking-tight mt-1">{quiz.name}</h1>
      <div className="flex gap-1 mt-4 mb-8">
        {quiz.questions.map((_, i) => (
          <div key={i} className={`h-1 flex-1 rounded-full ${i <= idx ? "bg-[#D4AF37]" : "bg-white/15"}`} />
        ))}
      </div>
      <AnimatePresence mode="wait">
        <motion.div key={idx} initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -30 }} transition={{ duration: 0.2 }}>
          <h2 className="text-xl font-bold mb-5">{q.q}</h2>
          <div className="space-y-3">
            {q.options.map((o, i) => (
              <button key={i} data-testid={`personality-option-${i}`} onClick={() => answer(i)}
                className="w-full text-left rounded-2xl bg-[#121212] border border-white/10 hover:border-[#D4AF37]/50 px-4 py-4 text-sm transition-colors">
                {o.t}
              </button>
            ))}
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
